import React from 'react'
import Grid from '@mui/material/Grid'
import AnDateField from '../../../../../../components/DateTime/DateField'
import moment from 'moment'

const Expiry = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} md={6} lg={3}>
    <AnDateField
      date={moduleValues?.['Expiry'] ?? null}
      onChange={(newDate) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Expiry']: moment(newDate).toISOString(),
        }))
      }
      label="Expiry Date"
      fullWidth
      disablePast
    />
  </Grid>
)

export default Expiry
